<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("SIDENAV.Pages.show") }}</h4>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">

          <!-- Start:: Name Input -->
          <base-input col="6" type="text" :placeholder="$t('PLACEHOLDERS.nameAr')" v-model.trim="data.nameAr" disabled />
          <!-- End:: Name Input -->

          <!-- Start:: Name Input -->
          <base-input col="6" type="text" :placeholder="$t('PLACEHOLDERS.nameEn')" v-model.trim="data.nameEn" disabled />
          <!-- End:: Name Input -->

          <!-- Start:: text editor Input -->
          <base-text-editor col="12" type="text" :placeholder="$t('PLACEHOLDERS.contentEn')" v-model.trim="data.contentEn" disabled />
          <!-- End:: Name Input -->

          <!-- Start:: Name Input -->
          <base-text-editor col="12" type="text" :placeholder="$t('PLACEHOLDERS.contentAr')" v-model.trim="data.contentAr" disabled />
          <!-- Start:: Deactivate Switch Input -->
          <!--<div class="input_wrapper switch_wrapper my-5">-->
            <!--<v-switch color="green" :label="data.active ? $t('PLACEHOLDERS.active') : $t('PLACEHOLDERS.notActive')"-->
              <!--v-model="data.active" hide-details disabled></v-switch>-->
          <!--</div>-->
          <!-- End:: Deactivate Switch Input -->

        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>

export default {
  name: "showPage",

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        nameAr: null,
        nameEn: null,
        contentAr: null,
        contentEn: null,
      },
      // End:: Data Collection To Send
    };
  },

  computed: {
  },

  methods: {
    // start show data
    async showPage() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `pages/${this.$route.params.id}`,
        });
        this.data.nameAr = res.data.data.Page.trans.name.ar;
        this.data.nameEn = res.data.data.Page.trans.name.en;
        this.data.contentAr = res.data.data.Page.trans.content.ar;
        this.data.contentEn = res.data.data.Page.trans.content.en;
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },
    // end show data


  },

  created() {
    // Start:: Fire Methods
    this.showPage();
    // End:: Fire Methods
  },
};
</script>
